import LatLng from '@/locations/models/lat-lng'

export default class Address {
  public addressLine = ''
  public postalCode = ''
  public city = ''
  public countryId = 'AT'
  public location: LatLng = new LatLng()
}
